<adaa-auth-layout>
    @if (step() === 1) {
        <div class="adaa-auth-subtitle">{{ "login.link_account_title" | translate }}</div>
        <p class="adaa-auth-text">{{ "login.have_account_question" | translate }}</p>

        <div class="adaa-auth-choice">
            <button type="button" class="adaa-auth-btn adaa-auth-btn-primary" (click)="linkAccount(true)">{{ "login.yes" | translate }}</button>
            <button type="button" class="adaa-auth-btn adaa-auth-btn-ghost mt-0" (click)="linkAccount(false)">
                {{ "login.no" | translate }}
            </button>
        </div>

        <p class="adaa-auth-text mb-5">{{ "login.uae_pass_link_note1" | translate }}</p>
        <p class="adaa-auth-text">{{ "login.uae_pass_link_note3" | translate }}</p>
    } @else if (linkAccountForm(); as accountForm) {
        <div class="adaa-auth-subtitle">{{ "login.link_account_title" | translate }}</div>
        <p class="adaa-auth-text">{{ "login.link_account_dsc" | translate }}</p>

        <form [formGroup]="accountForm" (ngSubmit)="submit()">
            <div class="adaa-auth-field">
                <adaa-form-input
                    controlName="email"
                    formControlName="email"
                    inputType="email"
                    [required]="true"
                    [placeholder]="'common.form.label.email' | translate"
                    [invalid]="
                        accountForm.get('password')?.dirty &&
                        (accountForm.get('email')?.errors?.['required'] || accountForm.get('email')?.errors?.['email'])
                    "
                />
            </div>

            <div class="adaa-auth-field adaa-auth-field--password">
                <adaa-form-input
                    controlName="password"
                    formControlName="password"
                    [required]="true"
                    [placeholder]="'common.form.label.password' | translate"
                    [inputType]="showPassword() ? 'text' : 'password'"
                    [invalid]="accountForm.get('password')?.dirty && accountForm.get('password')?.errors?.['required']"
                />
                <button type="button" class="adaa-auth-eye" (click)="showPassword.set(!showPassword())">
                    <i class="fa-solid" [class.fa-eye-slash]="showPassword()" [class.fa-eye]="!showPassword()"></i>
                </button>
            </div>

            <div class="adaa-auth-forgot">
                <a role="button" routerLink="/forget-password">{{ "login.forgot" | translate }}</a>
            </div>

            <button type="submit" class="adaa-auth-btn adaa-auth-btn-primary">
                <span>{{ "login.link_to_uae_pass" | translate }}</span>
            </button>
        </form>
    }
</adaa-auth-layout>
